import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { Col, Container, Image, Row } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import LogoutModal from '../Logout/LogoutModal'
function Menus({width}) {
    const [about, setAbout] = useState('')
    const [privacypolicy, setPrivacyPolicy] = useState('')
    const [refundpolicy, setRefundPolicy] = useState('')
    const [terms, setTermsCondition] = useState('')
    const [showModal, setShowModal] = useState(false); // 👈 for modal control
    useEffect(() => {
        getPages()
    }, []);
    const getPages = () => {
        let config = {
            method: 'get',
            maxBodyLength: Infinity,
            url: `${process.env.REACT_APP_API_URL}/pages`,
            headers: {
                'Authorization': localStorage.getItem('dastaan__token'),
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };
        axios.request(config).then((response) => {
            const data = response.data.data
            data.map((item) => {
                switch (item.page_name) {
                    case "Terms and Condition":
                        setTermsCondition(`pages/${item.page_name}`)
                        break;
                    case "Refund Policy":
                        setRefundPolicy(`pages/${item.page_name}`)
                        break;
                    case "Privacy Policy":
                        setPrivacyPolicy(`pages/${item.page_name}`)
                        break;
                    case "About Us":
                        setAbout(`pages/${item.page_name}`)
                        break;
                }
            })
        })
    }
    const userLogOut = () => {
        setShowModal(true)
        /*    localStorage.clear(); // remove all
           window.location.href = '/'; */
    }
    const user_id = localStorage.getItem('dastaan__user_id');
    return (
        <>
            <Container className={width > 768 && 'ml-10'} style={{ marginTop: '0%', padding: '25px' }}>
                <Row>
                    <Col md={11} xs={12} className='profile_menus'>
                        <Link to={'/' + about}>
                            <div>
                                <Row>
                                    <Col md={1} xs={1}>
                                        <Image className='menu-images' src={`${process.env.PUBLIC_URL}/player_icons/about.svg`} />
                                    </Col>
                                    <Col md={11} xs={11}> <span className='text-white menu-text'>About</span></Col>
                                </Row>
                            </div>
                        </Link>
                    </Col>
                    <Col md={11} xs={12} className='profile_menus'>
                        <Link to={'/' + privacypolicy}>
                            <div>
                                <Row>
                                    <Col md={1} xs={1}>
                                        <Image className='menu-images' src={`${process.env.PUBLIC_URL}/player_icons/Privacy_Policy.svg`} />
                                    </Col>
                                    <Col md={11} xs={11}> <span className='text-white menu-text' >Privacy Policy</span></Col>
                                </Row>
                            </div>
                        </Link>
                    </Col>
                    {/* share app */}
                    {/*  <Col md={12} xs={12} className='profile_menus'>
                        <Link>
                            <div>
                                <Row>
                                    <Col md={2} xs={1}>
                                    <Image className='menu-images' src={`${process.env.PUBLIC_URL}/player_icons/share_app.svg`} />
                                    </Col>
                                    <Col md={10} xs={11}> <span className='text-white menu-text' >Share App</span></Col>
                                </Row>
                            </div>
                        </Link>
                    </Col> */}
                    {/* Refund Policy */}
                    <Col md={11} xs={12} className='profile_menus'>
                        <Link to={'/' + refundpolicy}>
                            <div>
                                <Row>
                                    <Col md={1} xs={1}>
                                        <Image className='menu-images' src={`${process.env.PUBLIC_URL}/player_icons/Refund_Policy.svg`} />
                                    </Col>
                                    <Col md={11} xs={11}> <span className='text-white menu-text' >Refund Policy</span></Col>
                                </Row>
                            </div>
                        </Link>
                    </Col>
                    {/* terms conditions */}
                    <Col md={11} xs={12} className='profile_menus'>
                        <Link to={'/' + terms}>
                            <div>
                                <Row>
                                    <Col md={1} xs={1}>
                                        <Image className='menu-images' src={`${process.env.PUBLIC_URL}/player_icons/t&c.svg`} />
                                    </Col>
                                    <Col md={11} xs={11}> <span className='text-white menu-text' >Terms and Conditions</span></Col>
                                </Row>
                            </div>
                        </Link>
                    </Col>
                    {
                        user_id !== null && (<>
                            {/* Dashboard */}
                            <Col md={11} xs={12} className='profile_menus'>
                                <Link to="/dashboard">
                                    <div>
                                        <Row>
                                            <Col md={1} xs={1}><Image className='menu-images' src={`${process.env.PUBLIC_URL}/player_icons/Dashboard.svg`} /></Col>
                                            <Col md={11} xs={11}> <span className='text-white menu-text' >Dashboard</span></Col>
                                        </Row>
                                    </div>
                                </Link>
                            </Col>
                            {/* Logout */}
                            <Col md={11} xs={12} className='profile_menus' onClick={userLogOut} >
                                <div>
                                    <Row>
                                        <Col md={1} xs={1}><Image className='menu-images' src={`${process.env.PUBLIC_URL}/player_icons/logout.svg`} /> </Col>
                                        <Col md={11} xs={11} className='pointer'> <span className='text-white menu-text ' >Logout</span></Col>
                                    </Row>
                                </div>
                            </Col>
                        </>
                        )
                    }
                </Row>
            </Container>
            <LogoutModal show={showModal} onClose={() => setShowModal(false)} />
        </>
    )
}
export default Menus